const StatusEnum={
    online:"online",
    offline:"offline",
    snoozed:"snoozed", 
}

export default StatusEnum